import Vue from 'vue'
import App from './App.vue'
//引入VueRouter
import VueRouter from 'vue-router';
import router from './router'

import 'vant/lib/index.css';
import '@/assets/styles/tokens.css';
import {
  Button, Sticky, Search, Loading,
  Checkbox, CheckboxGroup, Col, Row,
  GoodsAction, GoodsActionIcon, GoodsActionButton,
  Tab, Tabs, Field, Icon, Popup, NavBar,
  ActionSheet, Toast, Image, Overlay
} from 'vant';

Vue.config.productionTip = false

Vue.use(VueRouter);

Vue.use(Button);
Vue.use(Sticky);
Vue.use(Search);
Vue.use(Loading);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Col);
Vue.use(Row);
Vue.use(GoodsAction);
Vue.use(GoodsActionButton);
Vue.use(GoodsActionIcon);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Field);
Vue.use(Icon);
Vue.use(Popup);
Vue.use(NavBar);
Vue.use(ActionSheet);
Vue.use(Toast);
Vue.use(Image);
Vue.use(Overlay);

new Vue({
  render: h => h(App),
  router:router
}).$mount('#app')
